// @flow
import $ from 'jquery';
import _ from 'lodash';
import { makeRequest } from './request';
import { datatablesArr } from './../components/datatables';
import { refreshTable } from './../components/datatables-helpers';
const datatableForm: Object = $('.js-datatableForm');

/**
 * Wysyła formularz i odświeza datatables
 * @param {jQuery} form - obiekt formularza
 * @returns {Function} - wykonuje makeRequest i odswieza tabelke
 */
function sendForm(form: Object): Function {
    const tablename = form.attr('data-tablename');
    const url = form.attr('action');
    const method = form.attr('method');
    const payload = {};

    _.mapValues(form.serializeArray(), (field: Object) => {
        payload[field.name] = field.value;
    });

    return makeRequest({ url, method, payload }, () => {
        refreshTable(datatablesArr[tablename]);
    });
}

function init() {
    if (datatableForm.length) {
        datatableForm.on('submit', function (e) {
            sendForm($(this));
            e.preventDefault();
        });
    }
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/layout/datatableForm.js